module.exports = __webpack_public_path__ + "img/light.fe8ebe44.svg";